import {
  action,
  makeAutoObservable,
  makeObservable,
  observable,
  toJS,
} from "mobx";
import _ from "lodash";

let init = {
  accessToken: "",
  loading: false,
  uid: "",
  usersCount: 0,
  revenue: 0,
  ordersCount: 0,
  uniqueUsersCount: 0,
};

let state = makeAutoObservable({ ...init });

export const setSpinner = action((e) => (state.loading = e));
export const setUid = action((e) => (state.uid = e));
export const setUsersCount = action((e) => (state.usersCount = e));
export const setUniqueUsersCount = action((e) => (state.uniqueUsersCount = e));
export const setRevenue = action((e) => (state.revenue = e));
export const setOrdersCount = action((e) => (state.ordersCount = e));
export const setAccessToken = action((e) => (state.accessToken = e));

export const reset = action(() => {
  state.loading = false;
  state.uid = "";
  state.usersCount = 0;
  state.revenue = 0;
  state.ordersCount = 0;
  state.uniqueUsersCount = 0;
  state.accessToken = "";
});

// export const reset = () => {
//   state.uid = "";
//   state.loading = false;
// };

export default state;
